import { ReactNode, FC, createContext, useState, useMemo } from 'react';
import * as types from '@models/types';

type LabourDemandPulseContextType = {
    topEmployersByQuarter?: types.TopEmployersByQuarterTypes[];
    setTopEmployersByQuarter?: React.Dispatch<React.SetStateAction<types.TopEmployersByQuarterTypes[]>>;
    treeMapInfo?: types.TreeMapInfoTypes;
    setTreeMapInfo?: React.Dispatch<React.SetStateAction<types.TreeMapInfoTypes>>;
    topSectorsAndOccupationsYearOnYear?: types.SectorAndISCO2AndISCO4OccupationTypes;
    setTopSectorsAndOccupationsYearOnYear?: React.Dispatch<React.SetStateAction<types.SectorAndISCO2AndISCO4OccupationTypes>>;
    unemployedJobPosts?: types.UnemployedJobPostsTypes;
    setUnemployedJobPosts?: React.Dispatch<React.SetStateAction<types.UnemployedJobPostsTypes>>;
};

const LabourDemandPulseContext = createContext<LabourDemandPulseContextType>({});


type LabourDemandPulseProps = {
    children: ReactNode;
};

const LabourDemandPulse: FC<LabourDemandPulseProps> = ({ children }) => {
    const [topEmployersByQuarter, setTopEmployersByQuarter] = useState<types.TopEmployersByQuarterTypes[]>([]);
    const [treeMapInfo, setTreeMapInfo] = useState<types.TreeMapInfoTypes>({ sectors: [], occupations: [] });
    const [topSectorsAndOccupationsYearOnYear, setTopSectorsAndOccupationsYearOnYear] = useState<types.SectorAndISCO2AndISCO4OccupationTypes>({ sectors: [], isco2_occupations: [], isco4_occupations: [] });
    const [unemployedJobPosts, setUnemployedJobPosts] = useState<types.UnemployedJobPostsTypes>({});


    const LabourDemandPulseProviderValue = useMemo(
        () => ({
            topEmployersByQuarter, setTopEmployersByQuarter,
            treeMapInfo, setTreeMapInfo,
            topSectorsAndOccupationsYearOnYear, setTopSectorsAndOccupationsYearOnYear,
            unemployedJobPosts, setUnemployedJobPosts
        }),
        [
            topEmployersByQuarter, setTopEmployersByQuarter,
            treeMapInfo, setTreeMapInfo,
            topSectorsAndOccupationsYearOnYear, setTopSectorsAndOccupationsYearOnYear,
            unemployedJobPosts, setUnemployedJobPosts
        ]
    );

    return (
        <LabourDemandPulseContext.Provider value={LabourDemandPulseProviderValue}>
            {children}
        </LabourDemandPulseContext.Provider>
    );
};

export { LabourDemandPulse, LabourDemandPulseContext };